import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=01bc8e26&scoped=true"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"
import style0 from "./Programs.vue?vue&type=style&index=0&id=01bc8e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc8e26",
  null
  
)

export default component.exports